export default "__VITE_PUBLIC_ASSET__305f2418__"